import { FormControl } from '@mui/material'

import styled from 'styled-components'

export const StyledCheckboxGroup = styled(FormControl)`
  display: flex;
  flex-direction: column;

  & .MuiFormLabel-root {
    margin-bottom: 0;
  }

  .checkbox {
    &-label-box {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
    }

    &-label {
      cursor: pointer;
      font-weight: 450;
      font-size: 14px;
      line-height: 21px;
      color: #6f6f6f;
    }

    &-group {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      flex-wrap: nowrap;
      gap: 16px;
    }

    &-item {
      width: 100%;
    }

    &-button {
      width: 100%;
      display: flex;
      align-items: center;
      min-height: 64px;
      height: fit-content;
      border: 1px solid #d5dadf;
      border-radius: 8px;
      background-color: #ffffff;
      padding: 8px 16px 8px 10px;
      margin: 0;

      &.checked {
        border: 2px solid #bb945c;
        background-color: #fdfbf7;
      }

      .MuiFormControlLabel-label {
        width: 100%;
        display: block;
      }
    }

    &-button-box {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      width: 100%;
      gap: 16px;
    }

    &-button-footer {
      margin-top: 12px;
      width: 100%;
    }

    &-button-content {
      flex: 1;
      min-width: 0;
    }

    &-button-price {
      margin-left: auto;
      flex-shrink: 0;
      display: flex;
      align-items: flex-start;
      justify-content: flex-end;
    }

    &-button-price-text {
      white-space: nowrap;
    }

    &-button-label {
      display: block;
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #1d1d1d;
      white-space: pre-line;

      @media (max-width: 1024px) {
        font-size: 14px;
      }
    }

    &-button-label-description {
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;

      @media (max-width: 1024px) {
        font-size: 14px;
      }
    }

    &-helper-text {
      margin-left: 0;
      font-weight: 300;
      font-size: 14px;
      line-height: 24px;
      color: #6f6f6f;
    }

    &-content-tooltip {
      padding: 0;
      margin-top: 2px;
      flex-shrink: 0;
    }

    &-content-tooltip-inline {
      display: inline-flex;
      vertical-align: middle;
      margin-top: 0;
      margin-left: 2px;
    }

    &-tooltip-inline-wrap {
      white-space: nowrap;
    }
  }
`
